"use client";

import "./MobileAppTestimonialSection.scss";
import user from "@/assets/images/testimonial/user.png";
import employee from "@/assets/images/testimonial/employee.png";
import client from "@/assets/images/testimonial/client.png";
import ClientTestimonialsSection from "@/components/ClientTestimonialsSection/ClientTestimonialsSection";

const MobileAppTestimonialSection = () => {
  const MobileApptestimonialsData = [
    {
      name: "Meera Thiyagarajan",
      label: " Operations Director,  LogiMove · Chennai ",
      description:
        "We came to them with a broken codebase from another agency. They didn't just fix it, they rebuilt the architecture, and we launched a product we're actually proud of.",
      image: client,
    },
    {
      name: "Rohan Krishnan ",
      label: "CEO, HealthPlus · Mumbai",
      description:
        "Handed over a Figma file and a voice note. GSUS turned it into a live logistics app in 10 weeks. The driver-side experience alone saved us 4 hours of dispatch work daily.",
      image: employee,
    },
    {
      name: "Sarah Kim",
      label: "CTO, FinLoop",
      description:
        "I was terrified of handing our entire product vision to an outside team. Three months in, we had an app for our investors called 'enterprise-grade from day one.",
      image: user,
    },
    {
      name: "Dinesh Babu",
      label: "Goat Farmer",
      description:
        "Expense tracking became very clear after using GOATAPP. We finally understand where our farm costs are going.",
      image: client,
    },
    {
      name: "PORTEA",
      label: "Modern Form Owner",
      description:
        "Partnering with GSUS Star Software Solutions for our SAP implementation has been a game-changer. We've achieved unparalleled business control, streamlined our resources, and unlocked innovative solutions.",
      image: employee,
    },
  ];
  return (
    <>
      <ClientTestimonialsSection
        title="Trusted by Mobile App"
        highlightTitle="Shop Owners"
        description="Trusted by growning meat brands and local butchers shops, the platform improves operational speed and keeps every department connected in real-time."
        testimonialsData={MobileApptestimonialsData}
      />
    </>
  );
};

export default MobileAppTestimonialSection;
